module.exports = __webpack_public_path__ + "static/media/headerimage.cdead91b.png";